export const environment = {
    production: false,    
    apiUrl: 'https://api.ofs.dev.zsservices.com',
    idmLoginUrl: 'https://idm.dev.zsservices.com/OFS/IdentityManager/app/Web/login.aspx',
    idmMyAccount: 'https://idm.dev.zsservices.com/OFS/IdentityManager/app/Web/MyAccount.aspx',
    idmLogoffUrl: 'https://idm.dev.zsservices.com/OFS/IdentityManager/app/Web/Logout.aspx?returnUrl=https%3a%2f%2fidm.dev.zsservices.com%2fOFS%2fIdentityManager%2fapp%2fWeb%2fMyAccount.aspx'
  };